export default "__VITE_ASSET__DnRTXIuL__"